<template>
  <div class="container-fluid">
    <!-- Modal Structure -->
    <div id="changePasswordModal" class="modal">
      <div class="modal-content">
        <h4>{{ user.UserV61id === -1 ? 'Set' : 'Change' }} password</h4>
        <div class="row">
          <div class="input-field col s12">
            <input v-model="password" placeholder="new password" id="password" type="password">
            <input v-model="passwordConfirm" placeholder="repeat password" id="passwordRepeat" type="password">
            <label for="password" class="active">Password must be at least 8 characters</label>
          </div>
          <div class="col s6 offset-s6 right-align">
            <label v-show="password !== passwordConfirm && password.length >= 8 && passwordConfirm.length >= 8" for="email" style="color: red">Passwords do not match</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">Cancel</a>
        <a href="#!" class="modal-close waves-effect waves-green btn-flat" :class="{disabled: password !== passwordConfirm || password.length < 8 || passwordConfirm.length < 8}">Save</a>
      </div>
    </div>

    <div class="col s6" v-show="user !== null && user !== undefined">
      <!--
      cur UserId {{currentUser}}
      load UserV61id {{user}}
      -->
      <div class="row">
        <div class="input-field col s12">
          <input
          v-model="user.Email"
          placeholder="Email"
          id="email"
          type="email"
          class="validate"
          @input="$v.form.email.$touch"
          :state="$v.form.email.$dirty ? !$v.form.email.$error : null">
          <label for="email" class="active">Email</label>
          <span class="helper-text" data-error="Please enter a valid email address" data-success=""></span>
        </div>

        <div class="col s12">
          <div class="row no-margin">
            <div class="col s12">
              <label class="active">Password</label>
            </div>
          </div>

          <div class="row">
            <div class="col s12">
              <a v-if="currentUser.SystemRoleId !== 1 || currentUser.UserId !== user.UserV61id || user.UserV61id !== -1 "
                style="min-width: 150px; margin-right: 12px"
                class="waves-effect waves-light btn modal-trigger"
                data-target="changePasswordModal">{{ user.UserV61id === -1 ? 'Set' : 'Change' }} password</a>
              <a v-else
                style="min-width: 150px; margin-right: 12px;"
                class="waves-effect waves-light btn"
                @click="resetPassword()">Reset password</a>
            </div>
          </div>
        </div>

        <div class="input-field col s12" v-if="currentUser.SystemRoleId !== 1 && user.UserV61id !== -1">
          <a style="min-width: 150px; margin-right: 12px" @click="resetDesclaimer()"
          class="waves-effect waves-light btn"
          :class="{ disabled: !user.IsDisclaimerOk }">Reset disclaimer</a>
        </div>

        <div class="input-field col s12">
          <input input v-model="user.FirstName" placeholder="First name" id="firstname" type="text">
          <label for="firstname" class="active">First name</label>
        </div>

        <div class="input-field col s12">
          <input input v-model="user.MiddleName" placeholder="Middle name" id="middlename" type="text">
          <label for="middlename" class="active">Middle name</label>
        </div>

        <div class="input-field col s12">
          <input input v-model="user.LastName" placeholder="Last name" id="lastname" type="text">
          <label for="lastname" class="active">Last name</label>
        </div>

        <div class="input-field col s12" v-if="currentUser.UserId !== user.UserV61id">
          <label class="active">Expiration date</label>
          <v-date-picker v-model="user.AccountExpires" :min-date='new Date()'>
            <input
              class="bg-white border px-2 py-1 rounded"
              :value="userExpirationDate"
            />
          </v-date-picker>
        </div>

        <div class="input-field col s12" v-if="currentUser.SystemRoleId > 1">
          <select v-model="user.SystemRoleId">
            <option v-for="value in systemRoles" v-bind:key="value.SystemRoleId" :value="value.SystemRoleId">{{ value.Role }}</option>
          </select>
          <label>Role</label>
        </div>
        <div class="col s12" v-else>
          <p>Role: User</p>
        </div>

        <div class="input-field col s12">
          <input input v-model="user.MobilePhone" placeholder="Mobile" id="mobile" type="text">
          <label for="mobile" class="active">Mobile</label>
        </div>

        <div class="input-field col s12">
          <select v-model="user.LanguageId">
            <option v-for="language in languages" v-bind:key="language.Id" :value="language.Id">{{ language.Name }}</option>
          </select>
          <label>Language</label>
        </div>

        <div class="input-field col s12" v-if="currentUser.SystemRoleId > 1 && currentUser.UserId !== user.UserV61id">
          <select v-model="user.UserStatus">
            <option v-for="value in userStatus" v-bind:key="value.UserStatus" :value="value.UserStatus">{{ value.Status }}</option>
          </select>
          <label>User status</label>
        </div>
        <div class="col s12" v-else>
          <p>Status: {{ (user.UserStatus === 0 ? 'Inactive' : 'Active') }}</p>
        </div>

        <div class="input-field col s12" v-if="currentUser.SystemRoleId > 2">
          <select v-model="user.OrganisationId">
            <option v-for="organisation in organisations" v-bind:key="organisation.id" :value="organisation.id">{{ organisation.name }}</option>
          </select>
          <label>Organisation</label>
        </div>
        <div class="col s12" v-else>
          <p>Organisation: {{ getUserOrganisation(user.OrganisationId) }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import sha1 from 'js-sha1'
import {required, email} from 'vuelidate/lib/validators'
import moment from 'moment'
import UsersApi from '@/services/api/UsersApi'

export default {
  props: ['user', 'currentUser', 'languages', 'organisations'],
  data: function () {
    return {
      systemRoles: [],
      expirationDate: null,
      userStatus: [
        { UserStatus: 0, Status: 'Inactive' },
        { UserStatus: 1, Status: 'Active' }
      ],
      password: '',
      passwordConfirm: ''
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  computed: {
    userExpirationDate: function () {
      return this.formatDateTime(this.user.AccountExpires)
    }
  },
  mounted: function () {
    M.Modal.init(document.querySelectorAll('.modal'), { dismissible: true, endingTop: '5%' })
    this.setSystemRoles()
  },
  methods: {
    resetDesclaimer: function () {
      UsersApi.resetDisclaimer(this.user.UserV61id).then(result => {
        this.user.IsDisclaimerOk = false
        this.$notify({
          group: 'alerts',
          type: 'success',
          title: 'Disclaimer reset succes',
          text: result.data
        })
      })
    },
    resetPassword: function () {
      // reset password for external user
    },
    getUserOrganisation: function (organisationId) {
      if (organisationId > 0 && this.organisations.filter(o => o.id === organisationId).length > 0) {
        return this.organisations.filter(o => o.id === organisationId)[0].name
      }
    },
    setSystemRoles: function () {
      this.systemRoles = []
      switch (this.currentUser.SystemRoleId) {
        case 1: {
          this.systemRoles.push({ SystemRoleId: 1, Role: 'User' })
          break
        }
        case 2: {
          this.systemRoles.push({ SystemRoleId: 1, Role: 'User' })
          this.systemRoles.push({ SystemRoleId: 2, Role: 'Admin' })
          break
        }
        case 3: {
          this.systemRoles.push({ SystemRoleId: 1, Role: 'User' })
          this.systemRoles.push({ SystemRoleId: 2, Role: 'Admin' })
          this.systemRoles.push({ SystemRoleId: 3, Role: 'SuperUser' })
        }
      }
    },
    formatDateTime: (dateTime) => {
      if (dateTime !== null) {
        return moment(String(dateTime)).format('DD-MM-YYYY')
      }
      return ('-')
    }
  },
  watch: {
    user: function () {
      this.setSystemRoles()
    },
    password: function (val) {
      if (!val) {
        this.user.PasswordHash = null
      } else {
        this.user.PasswordHash = sha1(val).toUpperCase()
      }
    }
  }
}
</script>

<style scoped>
p {
  margin-top: 12px;
  margin-bottom: 12px;
}

.inline-icon {
   vertical-align: bottom;
}

/* BUTTON */
.btn-floating:hover {
  background-color: #F39810;
}

.btn:hover, .btn-large:hover, .btn-small:hover {
  background-color: #F39810;
}

.btn, .btn-large, .btn-small {
  background-color: #56CCF2;
}

[type="checkbox"]:indeterminate+span:not(.lever):before {
  border-right: 2px solid #56CCF2;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/_General.vue